import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import type { Chamber } from '@/types/raspi';

interface ResetCalibrationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chamber: Chamber | null;
  isResetting: boolean;
}

const ResetCalibrationDialog: React.FC<ResetCalibrationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  chamber,
  isResetting
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={isResetting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'error.main' }}>
        <WarningIcon color="error" />
        Reset Sensor Calibration?
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            This will <strong>permanently clear</strong> all sensor calibration offsets.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Sensors will return to factory calibration settings. All stored calibration data will be lost.
          </Typography>
        </Alert>

        {chamber && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Chamber ID:</strong> {chamber.chamber_id}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button 
          onClick={onClose} 
          disabled={isResetting}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          disabled={isResetting}
          variant="contained" 
          color="error"
        >
          {isResetting ? 'Resetting...' : 'Reset Calibration'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetCalibrationDialog;

